export class ModifyDdosAutoMitigationCommand {
  private automitigationstatus: boolean;

  constructor(automitigationstatus: boolean) {
    this.automitigationstatus = automitigationstatus;
  }

  get payload() {
    return { ddos_auto_mitigation: this.automitigationstatus };
  }
}
